import { render, staticRenderFns } from "./ReportRate.vue?vue&type=template&id=53748408&scoped=true"
import script from "./ReportRate.vue?vue&type=script&lang=js"
export * from "./ReportRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53748408",
  null
  
)

export default component.exports